"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOlType = exports.isOlTypeActive = exports.getActiveOlType = exports.setUlType = exports.isUlTypeActive = exports.getActiveUlType = exports.isListType = exports.LIST_TYPES = void 0;
const slate_1 = require("slate");
exports.LIST_TYPES = ['ul', 'ol', 'checklist', 'stepper'];
const isElement = (node) => slate_1.Element.isElement(node);
const isListType = (format) => exports.LIST_TYPES.includes(format);
exports.isListType = isListType;
const getActiveUlType = (editor) => {
    const { selection } = editor;
    if (!selection)
        return null;
    const match = slate_1.Editor.above(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && node.type === 'ul',
        mode: 'lowest',
    });
    if (!match)
        return null;
    const [element] = match;
    return element.ulType ?? 'disc';
};
exports.getActiveUlType = getActiveUlType;
const isUlTypeActive = (editor, ulType) => (0, exports.getActiveUlType)(editor) === ulType;
exports.isUlTypeActive = isUlTypeActive;
const setUlType = (editor, ulType) => {
    slate_1.Transforms.setNodes(editor, { ulType }, {
        match: (node) => isElement(node) && node.type === 'ul',
    });
};
exports.setUlType = setUlType;
const getActiveOlType = (editor) => {
    const { selection } = editor;
    if (!selection)
        return null;
    const match = slate_1.Editor.above(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && node.type === 'ol',
        mode: 'lowest',
    });
    if (!match)
        return null;
    const [element] = match;
    return element.olType ?? 'decimal';
};
exports.getActiveOlType = getActiveOlType;
const isOlTypeActive = (editor, olType) => (0, exports.getActiveOlType)(editor) === olType;
exports.isOlTypeActive = isOlTypeActive;
const setOlType = (editor, olType) => {
    slate_1.Transforms.setNodes(editor, { olType }, {
        match: (node) => isElement(node) && node.type === 'ol',
    });
};
exports.setOlType = setOlType;
